import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../config/api';

const AdminRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (token) {
      api.get('/auth/me')
        .then(res => setIsAdmin(res.data.is_admin === 1))
        .catch(() => setIsAdmin(false));
    } else {
      setIsAdmin(false);
    }
  }, [token]);

  if (!token) return <Navigate to="/login" replace />;
  if (isAdmin === null) return null;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return children;
};

export default AdminRoute;
